<template>
	<div>
		<div class="public-table-but__left">
			<div class="item">
				<div class="item-wp">
					<template v-if="queryShow">
						<div class="item-son">
							<el-input
								v-model="listParams.searchKey"
								placeholder="搜索关键词"
								clearable
								@keyup.enter.native="SearchAppList"
							></el-input>
						</div>
						<div class="item-son" style="width: 180px">
							<el-select
								v-model="listParams.companyId"
								clearable
								filterable
								placeholder="请选择主体"
								style="width: 100%"
							>
								<el-option
									v-for="(item, index) in companyData"
									:key="index"
									:label="item.name"
									:value="item.companyId"
								></el-option>
							</el-select>
						</div>
						<div class="item-son">
							<el-select
								v-model="listParams.status"
								clearable
								placeholder="请选择状态"
								style="width: 120px"
							>
								<el-option label="正常" value="1"></el-option>
								<el-option label="禁用" value="0"></el-option>
							</el-select>
						</div>
						<div class="item-son">
							<el-button type="primary" @click="SearchAppList"
								>查询 <i class="el-icon-search"></i>
							</el-button>
						</div>
					</template>
					<div class="item-son" v-if="addShow">
						<el-button type="primary" @click="handleClick('add')"
							>新增 <img src="@assets/images/add-icon.png" alt="" />
						</el-button>
					</div>
				</div>
			</div>
		</div>
		<div class="public-table-data">
			<el-table
				ref="multipleTable"
				size="medium"
				:data="tableData"
				border
				style="width: 100%"
				row-key="menuId"
				v-loading="loading"
			>
				<el-table-column type="index" label="序号" width="80" align="center">
				</el-table-column>
				<el-table-column prop="appLogo" label="Logo" width="120" align="center">
					<template slot-scope="scope">
						<el-image
							v-if="scope.row.appLogo"
							style="width: 50px; height: 50px"
							:src="scope.row.appLogo"
							fit="cover"
						></el-image>
					</template>
				</el-table-column>
				<el-table-column
					prop="appTypeName"
					label="类型"
					width="120"
					align="center"
				>
				</el-table-column>

				<el-table-column prop="appid" label="应用ID" width="200" align="center">
				</el-table-column>
				<el-table-column prop="swid" label="SWID" width="200" align="center">
				</el-table-column>

				<el-table-column prop="appName" label="名称" width="120" align="center">
				</el-table-column>
				<el-table-column
					prop="companyVo"
					label="主体"
					width="200"
					align="center"
				>
					<template slot-scope="scope">
						{{ scope.row.companyVo ? emptyShow(scope.row.companyVo.name) : "" }}
					</template>
				</el-table-column>
				<el-table-column prop="descr" label="说明" width="180" align="center">
				</el-table-column>
				<el-table-column prop="ctime" label="时间" width="180" align="center">
				</el-table-column>
				<el-table-column
					v-if="userInfo && userInfo.operateStatus == 1"
					prop="code"
					label="状态"
					width="100"
					align="center"
				>
					<template slot-scope="scope">
						<template>
							<el-switch
								:disabled="statusShow"
								v-model="scope.row.status"
								:active-value="1"
								:inactive-value="0"
								@change="changeSwitch(scope.row)"
								v-if="numType"
							>
							</el-switch>
							<el-switch
								:disabled="statusShow"
								v-else
								:value="scope.row.status"
								:active-value="1"
								:inactive-value="0"
								@change="operationShowTime"
							>
							</el-switch>
						</template>
					</template>
				</el-table-column>
				<el-table-column
					label="操作"
					align="left"
					fixed="right"
					min-width="370"
				>
					<template slot-scope="scope">
						<template v-if="userInfo && userInfo.operateStatus == 1">
							<el-button
								v-if="editShow"
								size="mini"
								@click="handleClick('edit', scope.row)"
								type="success"
								plain
								>编辑
							</el-button>
						</template>

						<el-button
							v-if="pgcShow"
							size="mini"
							@click="handleClick('content', scope.row)"
							type="warning"
							plain
							>内容
						</el-button>
						<el-button
							v-if="adShow"
							size="mini"
							@click="handleClick('advertising', scope.row)"
							type="warning"
							plain
							>广告
						</el-button>
						<el-button
							v-if="channeShow"
							size="mini"
							@click="handleClick('channel', scope.row)"
							type="warning"
							plain
							style="margin-bottom: 10px"
							>渠道
						</el-button>
						<el-button
							v-if="payShow"
							size="mini"
							@click="handleClick('pay', scope.row)"
							type="primary"
							plain
							>支付
						</el-button>
						<el-button
							v-if="mainNavShow"
							size="mini"
							@click="handleClick('nav', scope.row)"
							type="success"
							plain
							>导航
						</el-button>
						<el-button
							v-if="kefuShow"
							size="mini"
							@click="handleClick('service', scope.row)"
							type="success"
							plain
							>客服
						</el-button>
						<el-button
							v-if="protocolShow"
							size="mini"
							@click="handleClick('agreement', scope.row)"
							type="success"
							plain
							>协议
						</el-button>
						<el-button
							v-if="ddzxShow"
							size="mini"
							@click="handleClickorder(scope.row)"
							type="success"
							plain
							>订单咨询
						</el-button>
						<el-button
							size="mini"
							@click="handleClick('keyword', scope.row)"
							type="danger"
							plain
							v-if="keywordShow"
							>关键字
						</el-button>
						<el-button
							size="mini"
							@click="handleDelete(scope.row)"
							type="danger"
							plain
							v-if="deleteShow"
							>删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<div class="public-pagination">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="pages.pageNo"
					:page-sizes="[PAGE_SIZE, 50, 100, 200, 400]"
					:page-size="pages.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				>
				</el-pagination>
			</div>
		</div>

		<!-- 编辑弹框 -->
		<el-dialog
			:title="
				clickType == 'add'
					? '新增应用信息'
					: clickType == 'channel'
					? '关联渠道'
					: clickType == 'edit'
					? '编辑应用'
					: clickType == 'pay'
					? '关联支付'
					: clickType == 'nav'
					? '配置导航'
					: clickType == 'service'
					? '关联客服'
					: clickType == 'agreement'
					? '关联协议'
					: ' 编辑广告 '
			"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			width="820px"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<el-form
					ref="ruleForm"
					:rules="rules"
					:model="params"
					label-width="110px"
				>
					<div v-if="clickType == 'add' || clickType == 'edit'">
						<el-row>
							<el-col :span="12">
								<el-form-item class="item" label="LOGO">
									<upLoadImg
										:keyWord="'appLogo'"
										:params="params"
										v-if="flag"
									></upLoadImg>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item class="item" label="二维码">
									<upLoadImg
										:keyWord="'qrcode'"
										:params="params"
										v-if="flag"
									></upLoadImg>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row>
							<el-col :span="12">
								<el-form-item label="名称" prop="appName">
									<el-input
										clearable
										placeholder="应用名称"
										v-model="params.appName"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="类型" required prop="appType">
									<el-select
										v-model="params.appType"
										clearable
										filterable
										placeholder="请选择"
										:disabled="clickType == 'edit' ? true : false"
									>
										<el-option
											v-for="item in allAppType"
											:key="item.enumVal"
											:label="item.enumName"
											:value="item.enumVal"
										>
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row>
							<el-col :span="12">
								<el-form-item label="应用ID" prop="appid">
									<el-input
										clearable
										placeholder="如果不填写,系统将自动生成"
										v-model="params.appid"
										:disabled="clickType == 'edit' ? true : false"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="SWID" prop="swid">
									<el-input
										clearable
										placeholder="应用推广标识"
										v-model="params.swid"
									></el-input>
								</el-form-item>
							</el-col>

							<el-col :span="24">
								<el-form-item required label="主体" prop="companyId">
									<el-select
										v-model="params.companyId"
										clearable
										filterable
										placeholder="请选择主体"
										@change="changeMain"
										style="width: 100%"
										:disabled="clickType == 'edit' ? true : false"
									>
										<el-option
											v-for="(item, index) in companyData"
											:key="index"
											:label="item.name"
											:value="item.companyId"
										></el-option>
									</el-select>
								</el-form-item>
							</el-col>

							<el-col :span="24">
								<el-form-item required label="业务域名" prop="domainBizId">
									<el-select
										v-model="params.domainBizId"
										clearable
										filterable
										placeholder="请选择业务域名"
										style="width: 100%"
										:disabled="
											params.companyId && params.companyId != '' ? false : true
										"
									>
										<el-option
											v-for="item in allDomainList"
											:key="item.domainBizId"
											:label="item.domainBizAddress"
											:value="item.domainBizId"
										>
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>

							<el-col :span="24">
								<el-form-item label="内部说明">
									<el-input
										type="textarea"
										:rows="4"
										maxlength="200"
										placeholder="最长为200个字符"
										v-model="params.descr"
									></el-input>
								</el-form-item>
							</el-col>

							<el-col :span="24">
								<el-form-item label="外部介绍">
									<el-input
										type="textarea"
										:rows="4"
										maxlength="200"
										placeholder="最长为200个字符"
										v-model="params.intro"
									></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<!-- 微信//app分开 -->
					</div>

					<!-- 渠道 -->
					<el-row v-if="clickType == 'channel'">
						<el-form-item label="名称：">
							<span v-if="params.companyVo"
								>{{ params.companyVo.name }} ( {{ params.appName }} )</span
							>
						</el-form-item>
						<el-form-item label="应用ID：">
							<span v-if="params.appid">{{ params.appid }}</span>
						</el-form-item>
						<el-form-item label=" 渠道：" prop="channelAccountIds">
							<el-select
								v-model="params.channelAccountIds"
								clearable
								multiple
								filterable
								no-data-text="暂无渠道"
								placeholder="请选择渠道"
								style="width: 100%"
								@change="$forceUpdate()"
							>
								<el-option
									v-for="(item, index) in channelData"
									:key="`${index}`"
									:label="`${item.channelTypeName} ( ${item.account} - ${item.code} )`"
									:value="item.channelAccountId"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-row>

					<!-- 支付 -->
					<el-row v-if="clickType == 'pay'" v-loading="loading">
						<el-form-item label="名称：">
							<span v-if="params.companyVo"
								>{{ params.appName }}({{ params.appTypeName }})</span
							>
						</el-form-item>
						<el-form-item label="应用ID：">
							<span v-if="params.appid">{{ params.appid }}</span>
						</el-form-item>
						<el-form-item label=" 渠道：">
							<el-tag
								:class="{ 'tag-marr': true, 'active-bg1': navIndex == index }"
								v-for="(item, index) in areadyPayChannnel"
								:key="index"
								@click="activeEventNav(index, item.channelAccountId)"
								effect="plain"
								type="danger"
								>{{ item.channelTypeName }} ({{ item.code }})
							</el-tag>
						</el-form-item>
						<el-form-item label=" 支付方式：">
							<el-tag
								:class="{
									'tag-marr': true,
									'active-bg1': chilckType == item.type,
								}"
								v-for="(item, index) in payType"
								:key="index"
								@click="activePayEventNav(item)"
								effect="plain"
								type="danger"
								>{{ item.name }}
							</el-tag>
						</el-form-item>
						<div class="info_tabs_wechat">
							<div class="radio_box">
								<div>模式：</div>
								<div>
									<el-radio v-model="radio_mode" :label="1">主商户号</el-radio>
									<el-radio v-model="radio_mode" :label="2">随机</el-radio>
								</div>
							</div>
							<!--              <div class="radio_box">-->
							<!--                <div>操作：</div>-->
							<!--                <el-button type="primary" size="mini" @click="hideSave" plain>保存</el-button>-->
							<!--              </div>-->
							<div class="box_chang_info">
								<div>域名：</div>
								<div class="tab_info">
									<div class="tab_head_tou">
										<div class="one_line td_head">序号</div>
										<div
											class="two_line td_head"
											style="width: 140px; padding: 5px"
										>
											商户信息
										</div>
										<div class="two_line td_head" style="">域名</div>
										<div class="one_line td_head">主/备</div>
										<div class="one_line last_line td_head">操作</div>
									</div>
									<div
										class="tab_head_tou"
										v-for="(item, index) in payMentListInfo"
										:key="index"
									>
										<div class="one_line td_head">{{ index + 1 }}</div>
										<div
											class="two_line td_head"
											style="width: 140px; padding: 5px"
										>
											{{ item.mchId }}
										</div>
										<div class="two_line td_head">{{ item.mchName }}</div>
										<div class="one_line td_head">
											<el-switch
												v-model="item.main"
												:active-value="1"
												:inactive-value="0"
												:disabled="item.main == 1"
												@change="changeSwitchTab(item, index)"
											>
											</el-switch>
										</div>
										<div class="one_line last_line td_head">
											<el-button
												plain
												@click="delectChangBox(item, index)"
												type="danger"
												style="margin-right: 0"
												size="mini"
												icon="el-icon-delete"
												circle
											></el-button>
										</div>
									</div>
									<div
										class="tab_head_tou _tab_add"
										@click="add_info_tab"
										v-if="click"
									>
										<i class="el-icon-plus"></i>
									</div>
								</div>
							</div>
						</div>
					</el-row>
					<!-- 导航 -->
					<el-row v-if="clickType == 'nav'">
						<el-form-item label="名称：">
							<span v-if="params.companyVo"
								>{{ params.appName }}({{ params.appTypeName }})</span
							>
						</el-form-item>
						<el-form-item label="应用ID：">
							<span v-if="params.appid">{{ params.appid }}</span>
						</el-form-item>
						<el-form-item label="导航：">
							<el-checkbox-group v-model="checkListNav">
								<el-checkbox
									v-for="(item, idx) in navList"
									:key="idx"
									:label="item.appNavId"
									>{{ item.name }}
								</el-checkbox>
							</el-checkbox-group>
						</el-form-item>
					</el-row>

					<!-- 客服 -->
					<el-row v-if="clickType == 'service'">
						<el-form-item label="名称：">
							<span v-if="params.companyVo"
								>{{ params.appName }}({{ params.appTypeName }})</span
							>
						</el-form-item>
						<el-form-item label="应用ID：">
							<span v-if="params.appid">{{ params.appid }}</span>
						</el-form-item>
						<el-form-item label="客服渠道：">
							<el-checkbox-group v-model="checkListService">
								<el-checkbox
									v-for="item in serviceList"
									:label="item.customerServiceId"
									:key="item.customerServiceId"
									>{{ item.serviceTypeName }} - {{ item.name }} (
									{{ item.account }} )
								</el-checkbox>
							</el-checkbox-group>
						</el-form-item>
					</el-row>

					<!-- 协议 -->
					<el-row v-if="clickType == 'agreement'">
						<el-form-item label="名称：">
							<span v-if="params.companyVo"
								>{{ params.appName }}({{ params.appTypeName }})</span
							>
						</el-form-item>
						<el-form-item label="应用ID：">
							<span v-if="params.appid">{{ params.appid }}</span>
						</el-form-item>
						<el-form-item label="协议：" prop="companyId">
							<el-checkbox-group v-model="checkListAgreement">
								<!-- <el-checkbox v-for="(item,index) in agreementList" :key="index" :label="`${item.protocolTypeName}- ${item.name} ( ${item.account} )`"></el-checkbox> -->
								<el-checkbox
									v-for="(item, index) in agreementList"
									:key="index"
									:label="item.protocolInfoId"
									>{{ `${item.protocolTypeName}- ${item.name}` }}
								</el-checkbox>
							</el-checkbox-group>
						</el-form-item>
					</el-row>
				</el-form>
			</div>

			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="dialogVisible = false"
					>取 消</el-button
				>

				<template v-if="clickType == 'edit'">
					<el-button
						size="medium"
						type="primary"
						@click="handleEdit"
						v-if="numType"
						>提 交</el-button
					>
					<el-button
						size="medium"
						type="primary"
						@click="operationShowTime"
						v-if="!numType"
						>提 交</el-button
					>
				</template>
				<template v-else>
					<el-button size="medium" type="primary" @click="handleEdit"
						>提 交</el-button
					>
				</template>
				<el-button
					size="medium"
					type="primary"
					v-if="clickType == 'edit'"
					@click="changConfiguration"
					>开发配置</el-button
				>
			</span>
		</el-dialog>
		<!--    关注引导语弹窗-->
		<el-dialog
			title="关注引导语设置"
			:visible.sync="AttentionGuideShow"
			:close-on-click-modal="false"
			width="580px"
			class="public-dialog"
		>
			<div class="order-orderlist">
				<div class="oerdasf">
					<div>
						<el-input
							type="textarea"
							:rows="2"
							placeholder="请输入内容"
							v-model="AttentionGuidetextarea"
							style="width: 100%"
							:autosize="{ minRows: 10, maxRows: 14 }"
						>
						</el-input>
					</div>
				</div>
			</div>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="AttentionGuideShow = false"
					>取 消</el-button
				>
				<el-button size="medium" type="primary" @click="AttentionGuideSave"
					>提 交</el-button
				>
			</span>
		</el-dialog>
		<!--    查询引导弹窗-->
		<el-dialog
			title="查询引导语设置"
			:visible.sync="GuideShow"
			:close-on-click-modal="false"
			width="580px"
			class="public-dialog"
		>
			<div class="order-orderlist">
				<div class="oerdasf">
					<div>
						<el-input
							type="textarea"
							:rows="2"
							placeholder="请输入内容"
							v-model="Guidetextarea"
							style="width: 100%"
							:autosize="{ minRows: 10, maxRows: 14 }"
						>
						</el-input>
					</div>
				</div>
			</div>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="GuideShow = false">取 消</el-button>
				<el-button size="medium" type="primary" @click="GuideSave"
					>提 交</el-button
				>
			</span>
		</el-dialog>
		<!--    订单弹窗-->
		<el-dialog
			title="订单咨询"
			:visible.sync="orders"
			:close-on-click-modal="false"
			width="580px"
			class="public-dialog"
		>
			<div class="order-orderlist">
				<div class="oerdasf">
					<div>类型:订单咨询</div>
					<div style="display: flex; margin-top: 20px">
						<div style="width: 60px">
							<span style="color: red">*</span>详情:
						</div>
						<div>
							<richText :keyWord="'detail'" :params="orderparams"></richText>
						</div>
					</div>
				</div>
			</div>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="orders = false">取 消</el-button>
				<el-button size="medium" type="primary" @click="handleorderss"
					>提 交</el-button
				>
			</span>
		</el-dialog>
		<!--开发配置-->
		<el-dialog
			title="开发配置"
			:visible.sync="configurationVistab"
			:close-on-click-modal="false"
			width="720px"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<el-form
					ref="ruleForm"
					:rules="configurationRules"
					:model="params"
					label-width="110px"
				>
					<div>
						<!-- app -->
						<el-row v-if="params.appType == 'APP'" ref="appRefer">
							<el-col :span="24">
								<el-divider content-position="left"
									><i class="el-icon-mobile-phone"></i>
									<span
										style="
											font-weight: 600;
											letter-spacing: 2px;
											margin-left: 5px;
										"
									>
										APP信息</span
									></el-divider
								>
								<el-form-item></el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="Key" prop="appkey">
									<el-input
										clearable
										placeholder="填写key"
										v-model="params.appkey"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="Secret" prop="appsecret">
									<el-input
										clearable
										placeholder="Secret"
										v-model="params.appsecret"
									></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<!-- 微信 -->
						<el-row v-else ref="wxRefer">
							<el-col :span="24">
								<el-form-item required label="ID" prop="rawid">
									<el-input
										clearable
										placeholder="ID"
										v-model="params.rawid"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="Key" prop="appkey">
									<el-input
										clearable
										placeholder="Key"
										v-model="params.appkey"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item required label="Secret" prop="appsecret">
									<el-input
										clearable
										placeholder="Secret"
										v-model="params.appsecret"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="三方账号" prop="account">
									<el-input
										clearable
										style="width: 380px"
										placeholder="三方账号"
										v-model="params.account"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="管理员姓名" prop="adminName">
									<el-input
										clearable
										placeholder="管理员姓名"
										v-model="params.adminName"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="管理员账号" prop="adminAccount">
									<el-input
										clearable
										placeholder="管理员账号"
										v-model="params.adminAccount"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="开启服务器" prop="validStatus">
									<el-switch
										v-model="params.validStatus"
										:active-value="1"
										:inactive-value="0"
									></el-switch>
								</el-form-item>
								<!--              :disabled="params.appType == 'WX_XCX' || params.appType == 'APP' ? true : false"-->
							</el-col>
							<div v-if="params.validStatus == 1">
								<el-col :span="24">
									<el-form-item required label="服务器地址" prop="url">
										<el-input
											clearable
											placeholder="服务器地址"
											v-model="params.url"
										></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="24">
									<el-form-item required label="令牌(Token)" prop="token">
										<el-input
											clearable
											placeholder="令牌(Token)"
											v-model="params.token"
										></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="24">
									<el-form-item required label="加解密密钥" prop="aeskey">
										<el-input
											clearable
											placeholder="加解密密钥"
											v-model="params.aeskey"
										></el-input>
									</el-form-item>
								</el-col>
							</div>
						</el-row>
					</div>
				</el-form>
				<span slot="footer" class="public-dialog-footer">
					<el-button size="medium" @click="configurationVistab = false"
						>取 消</el-button
					>
					<el-button
						size="medium"
						type="primary"
						@click="configurationHandleorderss"
						>提 交</el-button
					>
				</span>
			</div>
		</el-dialog>
		<!--支付商户列表-->
		<el-dialog
			title="支付商户列表"
			:visible.sync="merchantVistab"
			:close-on-click-modal="false"
			width="280px"
			class="public-dialog"
		>
			<div class="left_box_infos">
				<div
					class="cou_infos"
					@click="addChangBox(item, index)"
					v-for="(item, index) in payTypeChangList"
					:key="index"
				>
					{{ item.mchName }}({{ item.mchId }})<i
						style="margin-left: 5px"
						class="el-icon-circle-plus-outline"
					></i>
				</div>
			</div>
		</el-dialog>
		<!-- 导航 -->
		<el-dialog
			title="配置导航"
			:visible.sync="cardialogVisible"
			:close-on-click-modal="false"
			width="1180px"
			style="cursor: pointer"
			class="public-dialog"
		>
			<el-form ref="ruleForm" label-width="110px">
				<el-row v-if="clickType == 'nav'">
					<el-form-item label="名称：">
						<span v-if="params.companyVo"
							>{{ params.appName }}({{ params.appTypeName }})</span
						>
					</el-form-item>
					<el-form-item label="应用ID：">
						<span v-if="params.appid">{{ params.appid }}</span>
					</el-form-item>
					<el-form-item label="导航分类：">
						<div class="public-table-data" style="padding-bottom: 20px">
							<el-table
								ref="multipleTable"
								size="medium"
								:data="carContentList"
								border
								style="width: 100%"
								v-loading="loading"
							>
								<el-table-column
									type="index"
									label="序号"
									width="80"
									align="center"
								>
									<template slot-scope="scope">
										<span>{{ scope.$index + 1 }}</span>
									</template>
								</el-table-column>
								<el-table-column
									prop="name"
									label="名称"
									min-width="100"
									align="center"
								>
									<template slot-scope="scope">
										<div @click="handleInfoClick(scope.row)">
											{{ scope.row.name }}
										</div>
									</template>
								</el-table-column>
								<el-table-column
									prop="descr"
									label="说明"
									width="200"
									align="center"
								>
								</el-table-column>
								<el-table-column
									prop="descr"
									label="有效状态"
									align="left"
									width="80"
								>
									<template slot-scope="scope">
										<el-tag size="small" v-if="scope.row.timeStatus == 0"
											>未开启</el-tag
										>
										<el-tag size="small" v-if="scope.row.timeStatus == 1"
											>生效中</el-tag
										>
										<el-tag size="small" v-if="scope.row.timeStatus == 2"
											>已过期</el-tag
										>
									</template>
								</el-table-column>
								<el-table-column
									prop="descr"
									label="有效期"
									width="320"
									align="center"
								>
									<template slot-scope="scope">
										<span
											>{{ scope.row.startTime }} -
											{{ scope.row.expireTime }}</span
										>
									</template>
								</el-table-column>
								<el-table-column label="状态" align="center" width="80">
									<template slot-scope="scope">
										<el-switch
											:disabled="true"
											v-model="scope.row.status"
											:active-value="1"
											:inactive-value="0"
										>
										</el-switch>
									</template>
								</el-table-column>
								<el-table-column label="操作" width="100" align="center">
									<template slot-scope="scope">
										<el-button
											v-if="scope.row.showDeactivate"
											size="mini"
											type="danger"
											@click="changDeactivate(scope.row.appCatInfoId)"
											plain
											>停用
										</el-button>
										<el-button
											v-if="!scope.row.showDeactivate"
											size="mini"
											type="primary"
											@click="changEnable(scope.row.appCatInfoId)"
											plain
											>启用
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</el-form-item>
				</el-row>
			</el-form>
		</el-dialog>
		<!--导航详情-->
		<el-dialog
			title="导航详情"
			:visible.sync="navigationShow"
			:close-on-click-modal="false"
			width="450px"
			style="cursor: pointer"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<div class="box_chang_info">
					<div>名称：</div>
					<div>{{ navigationInstructionsInfo.name }}</div>
				</div>
				<div class="box_chang_info">
					<div>有效期：</div>
					<div>
						{{ navigationInstructionsInfo.startTime }}-{{
							navigationInstructionsInfo.expireTime
						}}
					</div>
				</div>
				<div class="box_chang_info">
					<div>有效状态：</div>
					<div>
						<el-tag
							size="small"
							v-if="navigationInstructionsInfo.timeStatus == 0"
							>未开启</el-tag
						>
						<el-tag
							size="small"
							v-if="navigationInstructionsInfo.timeStatus == 1"
							>生效中</el-tag
						>
						<el-tag
							size="small"
							v-if="navigationInstructionsInfo.timeStatus == 2"
							>已过期</el-tag
						>
					</div>
				</div>
				<div class="box_chang_info">
					<div>说明：</div>
					<div>{{ navigationInstructionsInfo.descr }}</div>
				</div>
			</div>
		</el-dialog>

		<operation-confirmation
			@closeOperation="publicMethios"
			:operationVisible="operationVisible"
		></operation-confirmation>
	</div>
</template>
<script>
import { PAGE_SIZE, FILE_ROOT, JOB_STATUS, TEST_ENGNUM } from "@config";
import { isEmpty, emptyShow } from "../../utils/tools/index";
import richText from "../../components/richText.vue";
import upLoadImg from "./components/upLoadImg.vue";
import OperationConfirmation from "../../components/OperationConfirmation";

export default {
	components: {
		upLoadImg,
		richText,
		OperationConfirmation,
	},
	data() {
		var checkAccount = (rule, value, callback) => {
			callback();
		};
		return {
			orderlistaa: {},
			isEmpty,
			chilckType: "WECHAT",
			payType: [
				{
					type: "WECHAT",
					name: "微信",
				},
				{
					type: "ALIPAY",
					name: "支付宝",
				},
			],
			merchantVistab: false,
			radio_mode: 1,
			payMentListInfo: [],
			payAppInfoId: "",
			allPayList: [],
			payTypeChangList: [],
			allPayInfoList: [],
			click: true,
			PAGE_SIZE,
			emptyShow,
			listParams: {
				appType: "WX_XCX",
			},
			companyData: [],
			appData: [],
			tableData: [],
			loading: false,
			pages: {
				pageNo: 1,
				pageSize: PAGE_SIZE,
			},
			total: 0,
			clickType: "",

			dialogVisible: false, //弹窗是否可见
			orders: false,
			params: {}, //弹窗修改数据
			rules: {
				appName: [
					{ required: true, message: "请填写名称", trigger: "blur" },
					{},
				],
				appType: [{ required: true, message: "请选择类型", trigger: "blur" }],
				appInfoId: [
					{ message: "请输入应用ID", trigger: "blur" },
					{
						validator: checkAccount,
						message: "只允许输入英文,数字",
					},
					{ max: 50, message: "最多50个字符" },
				],
				swid: [
					{ message: "请输入应用推广标识", trigger: "blur", required: true },
					{
						validator: checkAccount,
						message: "只允许输入英文,数字",
					},
					{ max: 6, message: "最多6个字符" },
				],
				companyId: [{ required: true, message: "请选择主体", trigger: "blur" }],
				domainBizId: [
					{ required: true, message: "请选择业务域名", trigger: "blur" },
				],
			}, //表单验证提示
			configurationRules: {
				rawid: [
					{ required: true, message: "请输入原始ID", trigger: "blur" },
					{
						validator: checkAccount,
						message: "只允许输入英文,数字",
						trigger: "blur",
					},
					{ max: 50, message: "最多50个字符" },
				],
				appkey: [
					{ required: true, message: "请输入appkey", trigger: "blur" },
					{
						validator: checkAccount,
						trigger: "blur",
					},
					// { max: 10, message: "最多10个字符" },
				],
				appsecret: [
					{ required: true, message: "请输入Secret", trigger: "blur" },
					{
						validator: checkAccount,
						message: "只允许输入英文,数字",
						trigger: "blur",
					},
					{ max: 50, message: "最多50个字符" },
				],
			}, //表单验证提示

			allAppType: [], //字典字段--app类型
			allDomainList: [], //所有业务域名列表

			flag: false, //销毁子组件
			channelData: [], //渠道

			areadyPayChannnel: [], //已经关联过的渠道支付商户

			navIndex: 0, //广告-默认激活
			payMentList: [],
			wxPlayData: [],
			aliPlayData: [],
			uniPlayData: [],

			checkListNav: [], //导航栏选中
			navList: [],

			checkListService: [], //客服选中
			serviceList: [],
			checkListAgreement: [], //协议选中
			agreementList: [],

			tempArray: [],
			orderparams: {
				vipFree: 0,
			},
			operationVisible: false,
			numType: false,
			GuideShow: false,
			Guidetextarea: "",
			showGuidetextarea: "",
			GuideInfo: {},
			AttentionGuideShow: false,
			AttentionGuidetextarea: "",
			showAttentionGuidetextarea: "",
			AttentionGuideInfo: {},

			configurationVistab: false,
			//查询
			queryShow: false,
			//添加
			addShow: false,
			//状态
			statusShow: true,
			//编辑
			editShow: false,
			//删除
			deleteShow: false,
			//渠道
			channeShow: false,
			//支付
			payShow: false,
			//导航
			mainNavShow: false,
			//协议
			protocolShow: false,
			//客服
			kefuShow: false,
			//订单咨询
			ddzxShow: false,
			//查询引导语
			cxydyShow: false,
			//关注引导语
			gzydyShow: false,
			//内容
			pgcShow: false,
			//广告
			adShow: false,
			//关键字
			keywordShow: false,

			configurationParames: {},

			cardialogVisible: false,
			carAppDataIds: [],
			carContentList: [],
			navigationShow: false,
			navigationInstructionsInfo: false,
		};
	},
	computed: {
		userInfo() {
			return this.$store.state.userInfo;
		},
	},
	created() {
		if (window.sessionStorage.getItem("operationKey")) {
			this.numType = true;
		}
		this.getAppType();
		this.companyList();
		this.appList();
		this.queryTableData();
		this.getPermissionButtonList();
	},

	watch: {
		dialogVisible() {
			if (this.dialogVisible == false && this.params != {}) {
				this.$refs["ruleForm"].resetFields();
				this.params = {};
				this.wxPlayData = [];
				this.aliPlayData = [];
				this.uniPlayData = [];
			}
		},
	},
	methods: {
		changConfiguration() {
			this.configurationVistab = true;
		},
		configurationHandleorderss() {
			this.$refs.ruleForm.validate((valid) => {
				if (!valid) return;
				this.$confirm("确认提交修改, 是否继续?", "提示", {
					type: "info",
				}).then(async () => {
					const { data: res } = await this.$put("/app/dev/info", this.params);
					if (res.result != 200) return;
					this.$message.success("操作成功!");
					this.configurationVistab = false;
				});
			});
		},

		getPermissionButtonList() {
			let PermissionButtonList = window.sessionStorage.getItem(
				"TaotanPermissionButton"
			);
			let arr = JSON.parse(PermissionButtonList);
			if (arr.length) {
				arr.map((item) => {
					if (item.code == "wechat:info:query") {
						this.queryShow = true;
					}
					if (item.code == "wechat:info:add") {
						this.addShow = true;
					}
					if (item.code == "wechat:info:status") {
						this.statusShow = false;
					}
					if (item.code == "wechat:info:edit") {
						this.editShow = true;
					}
					if (item.code == "wechat:info:delete") {
						this.deleteShow = true;
					}
					if (item.code == "wechat:info:channe:cfg") {
						this.channeShow = true;
					}
					if (item.code == "wechat:info:pay:cfg") {
						this.payShow = true;
					}
					if (item.code == "wechat:info:main:nav:cfg") {
						this.mainNavShow = true;
					}
					if (item.code == "wechat:info:protocol:cfg") {
						this.protocolShow = true;
					}
					if (item.code == "wechat:info:kefu:cfg") {
						this.kefuShow = true;
					}
					if (item.code == "wechat:info:ddzx:cfg") {
						this.ddzxShow = true;
					}
					if (item.code == "wechat:info:cxydy:cfg") {
						this.cxydyShow = true;
					}
					if (item.code == "wechat:info:gzydy:cfg") {
						this.gzydyShow = true;
					}
					if (item.code == "wechat:info:pgc:cfg") {
						this.pgcShow = true;
					}
					if (item.code == "wechat:info:ad:cfg") {
						this.adShow = true;
					}
					if (item.code == "wechat:info:keyword") {
						this.keywordShow = true;
					}
				});
			}
		},
		//关注引导语
		async hidenAttentionGuide(e) {
			this.AttentionGuideInfo = e;
			const { data: res } = await this.$get(
				"/wechat/resp/info?appid=" + e.appid + "&event=sub&respType=text"
			);
			if (res.result != 200) return;
			if (res.data) {
				this.AttentionGuidetextarea = res.data.content;
				this.showAttentionGuidetextarea = res.data.content;
			}
			this.AttentionGuideShow = true;
		},
		async AttentionGuideSave() {
			if (this.showAttentionGuidetextarea == "") {
				let params = {
					appid: this.AttentionGuideInfo.appid,
					content: this.AttentionGuidetextarea,
					event: "sub",
					respType: "text",
				};
				const { data: res } = await this.$post("/wechat/resp/info", params);
				if (res.result != 200) return;
				this.$message.success("添加成功!");
				this.AttentionGuideShow = false;
			} else {
				let params = {
					appid: this.AttentionGuideInfo.appid,
					content: this.AttentionGuidetextarea,
					event: "sub",
					respType: "text",
				};
				const { data: res } = await this.$put("/wechat/resp/info", params);
				if (res.result != 200) return;
				this.$message.success("修改成功!");
				this.AttentionGuideShow = false;
			}
		},
		//查询引导语
		async attentionGuide(e) {
			this.GuideInfo = e;
			const { data: res } = await this.$get(
				"/wechat/resp/info?appid=" + e.appid + "&event=query&respType=text"
			);
			if (res.result != 200) return;
			if (res.data) {
				this.Guidetextarea = res.data.content;
				this.showGuidetextarea = res.data.content;
			}
			this.GuideShow = true;
		},
		async GuideSave() {
			if (this.showGuidetextarea == "") {
				let params = {
					appid: this.GuideInfo.appid,
					content: this.Guidetextarea,
					event: "query",
					respType: "text",
				};
				const { data: res } = await this.$post("/wechat/resp/info", params);
				if (res.result != 200) return;
				this.$message.success("添加成功!");
				this.GuideShow = false;
			} else {
				let params = {
					appid: this.GuideInfo.appid,
					content: this.Guidetextarea,
					event: "query",
					respType: "text",
				};
				const { data: res } = await this.$put("/wechat/resp/info", params);
				if (res.result != 200) return;
				this.$message.success("修改成功!");
				this.GuideShow = false;
			}
		},
		activePayEventNav(e) {
			this.payMentListInfo = [];
			this.chilckType = e.type;
			this.getPlayment(this.payAppInfoId);
		},
		changeSwitchTab(items, indexs) {
			let arr = this.payMentListInfo;
			arr.map((item, index) => {
				if (index != indexs) {
					item.main = 0;
				}
			});
		},
		add_info_tab() {
			this.payTypeChangList = [];
			this.allPayInfoList.forEach((element) => {
				if (!isEmpty(element.paymentMchId)) {
					if (element.paymentType == this.chilckType) {
						this.payTypeChangList.push(element);
					}
				}
			});
			this.merchantVistab = true;
		},
		addChangBox(e, index) {
			let a = "";
			if (this.payMentListInfo.length) {
				this.payMentListInfo.map((item) => {
					if (item.paymentMchId == e.paymentMchId) {
						this.$message.error("该商户信息已添加");
						a = 1;
					}
				});
			}
			if (a == 1) {
				return false;
			}
			this.payMentListInfo.push(e);
			this.payTypeChangList.splice(index, 1);
			this.allPayInfoList.map((item, indexs) => {
				if (item.paymentMchId == e.paymentMchId) {
					this.allPayInfoList.splice(indexs, 1);
				}
			});
		},
		delectChangBox(e, index) {
			this.payTypeChangList.push(e);
			this.allPayInfoList.push(e);
			this.payMentListInfo.splice(index, 1);
		},
		//清楚缓存数据，重启密码验证
		clearStore() {
			window.sessionStorage.removeItem("operationKey");
			this.numType = false;
		},
		//关闭
		publicMethios(e) {
			this.operationVisible = false;
			if (e == "open") {
				this.numType = true;
				setTimeout(() => {
					window.sessionStorage.removeItem("operationKey");
					this.numType = false;
				}, 1800000);
			}
		},
		//调起字组件的操作密码框
		operationShowTime(e) {
			this.operationVisible = true;
		},
		/* 切换主体下的业务域名 */
		changeMain() {
			// if(this.params.companyId!=undefined&&this.params.companyId!=''){
			// this.isDisabled = false;

			// 获取 相关联的业务域名
			this.$get("domain/biz/list", {
				params: {
					status: 1,
					paging: false,
					// companyId:this.params.companyId
				},
			}).then((res) => {
				if (res.data.data != undefined) {
					this.allDomainList = res.data.data;
				} else {
					this.allDomainList = [];
				}
			});
			// this.params.domainBizId=''
			// }
		},
		/* 协议配置 */
		async getAgreementList() {
			this.agreementList = [];
			const { data: res } = await this.$get(
				`/protocol/list?companyId=${this.params.companyVo.companyId}`,
				{
					params: {
						status: 1,
						paging: false,
					},
				}
			);
			if (!isEmpty(res.data)) {
				this.agreementList = res.data;
			}
		},
		async areadyAgreement(appInfoId) {
			this.checkListAgreement = [];
			const { data: resData } = await this.$get(
				`/app/unite/protocol/ids?appInfoId=${appInfoId}`,
				{
					params: {
						status: 1,
						paging: false,
					},
				}
			);
			if (!isEmpty(resData.data)) {
				resData.data.forEach((element) => {
					this.checkListAgreement.push(element);
				});
			}
		},
		// 订单咨询提交
		async handleorderss() {
			const { data: resData } = await this.$post(`/app/intro/info`, {
				intro: this.orderparams.detail,
				appInfoId: this.orderlistaa.appInfoId,
			});
			if (resData.result != 200) return;
			this.orders = false;
			this.$message.success("提交成功");
		},
		/* 客服配置 */
		async getServiceList() {
			this.serviceList = [];
			const { data: res } = await this.$get("/customer/service/list", {
				params: {
					status: 1,
					paging: false,
				},
			});
			if (!isEmpty(res.data)) {
				this.serviceList = res.data;
			}
		},
		async areadyService(appInfoId) {
			this.checkListService = [];
			const { data: resData } = await this.$get(
				`/app/unite/customer/service/ids?appInfoId=${appInfoId}`,
				{
					params: {
						status: 1,
						paging: false,
					},
				}
			);
			if (!isEmpty(resData.data)) {
				resData.data.forEach((element) => {
					this.checkListService.push(element);
				});
			}
		},
		/* 导航配置 */
		async getNavList() {
			this.navList = [];
			const { data: res } = await this.$get("/app/nav/list", {
				params: {
					status: 1,
					paging: false,
				},
			});
			if (!isEmpty(res.data)) {
				this.navList = res.data;
			}
		},
		async areadyNav(appInfoId) {
			this.checkListNav = [];
			const { data: resData } = await this.$get(
				`/app/unite/nav/ids?appInfoId=${appInfoId}`,
				{
					params: {
						status: 1,
						paging: false,
					},
				}
			);
			if (!isEmpty(resData.data)) {
				resData.data.forEach((element) => {
					this.checkListNav.push(element);
				});
			}
		},
		// 订单咨询
		async handleClickorder(item) {
			this.orderparams.detail = "";
			// this.orderlistaa = {}
			this.orderlistaa = item;
			const { data: resData } = await this.$get(
				`/app/intro/info/` + item.appInfoId,
				{}
			);
			this.orderparams.detail = resData.data.intro;
			this.orders = true;
		},
		/* 获取选择项--支付商户--选项  不会更改的 */
		getPlayItems() {
			this.wxPlayData = [];
			this.aliPlayData = [];
			this.uniPlayData = [];
			let http = `/payment/mch/list?`;
			this.$get(`${http} `, {
				params: {
					status: 1,
					paging: false,
				},
			}).then((res) => {
				this.loading = false;
				if (!isEmpty(res.data.data)) {
					this.allPayInfoList = res.data.data;
				}
			});
		},
		/* 已经关联的 支付商户 */
		getPlayment(appInfoId) {
			this.payAppInfoId = appInfoId;
			this.params.paymentALI = "";
			this.params.paymentWX = "";
			this.params.paymentUNI = "";
			let m = this.areadyPayChannnel[this.navIndex].channelAccountId;
			this.$get(
				`/app/payment/mode/info?appInfoId=${appInfoId}&channelAccountId=${m}&paymentType=${this.chilckType}`,
				{
					status: 1,
					paging: false,
				}
			).then((res) => {
				if (!isEmpty(res.data.data)) {
					if (res.data.data.appPaymentVos) {
						this.payMentListInfo = res.data.data.appPaymentVos;
					} else {
						this.payMentListInfo = [];
					}
				} else {
					this.payMentListInfo = [];
				}
			});
		},

		/* 获取      的 渠道--渠道账户 */
		async getChannelData(companyId, callback) {
			this.loading = true;
			const { data: resData } = await this.$get(
				`/channel/account/list`,
				// `/channel/account/list?companyId=${companyId}`,
				{
					params: {
						status: 1,
						paging: false,
					},
				}
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.channelData = resData.data;

			if (callback) callback();
		},
		/* 获取该app下已经关联的渠道 */
		async getAreadyChannel(appInfoId) {
			const { data: resData } = await this.$get(
				`/app/channel/list?appInfoId=${appInfoId}`,
				{
					params: {
						status: 1,
						paging: false,
					},
				}
			);
			if (resData.result != 200) return;
			this.params.channelAccountIds = []; //渠道--

			if (!isEmpty(resData.data)) {
				this.areadyPayChannnel = resData.data; //支付--渠道

				this.navIndex = 0; // 默认激活

				let temp = resData.data;
				temp.forEach((element) => {
					this.params.channelAccountIds.push(element.channelAccountId);
				});
			} else {
				this.areadyPayChannnel = [];
				this.params.channelAccountIds = [];
			}
		},

		/* *
      app类型选项  / 业务域名
     */
		async getAppType() {
			const { data: res } = await this.$get("/enums/list/APP_TYPE");
			// const { data: resData } = await this.$get("/domain/biz/list");

			this.allAppType = res.data;
			// this.allDomainList = resData.data;
		},

		SearchAppList() {
			this.pages.pageNo = 1;
			this.queryTableData();
		},
		/**
		 * 应用管理列表
		 */
		async queryTableData() {
			this.loading = true;

			const { data: resData } = await this.$get("/app/list", {
				params: {
					...this.listParams,
					...this.pages,
				},
			});
			this.loading = false;
			if (resData.result != 200) return;
			this.tableData = resData.data;
			this.total = resData.page.count;
		},
		/**
		 * 主体列表（企业列表）
		 */
		async companyList() {
			this.loading = true;

			const { data: resData } = await this.$get("/company/list?paging=false");
			this.loading = false;
			if (resData.result != 200) return;
			this.companyData = resData.data;
		},

		/**
		 * 获取应用类型
		 */
		async appList() {
			this.loading = true;
			const { data: resData } = await this.$get(`/enums/list/APP_TYPE`);
			this.loading = false;
			if (resData.result != 200) return;
			this.appData = resData.data;
		},

		/**
		 * 表格按钮点击
		 */
		async handleClick(type, row = {}) {
			this.clickType = type;
			switch (type) {
				case "add":
					this.dialogVisible = true;
					this.flag = false;
					row.validStatus = 1;
					this.params = JSON.parse(JSON.stringify(row));
					this.$nextTick(() => {
						this.flag = true;
					});
					break;
				case "edit":
					this.dialogVisible = true;
					this.changeMain();
					this.flag = false;
					this.params = JSON.parse(JSON.stringify(row));
					this.$nextTick(() => {
						this.flag = true; //组件生命重新加载
					});

					break;
				case "channel":
					this.flag = false;
					this.params = JSON.parse(JSON.stringify(row));

					// 先获取其主体下 已经关联的渠道
					if (this.params.companyVo) {
						await this.getChannelData(this.params.companyVo.companyId); //获取渠道账户列表
					}
					if (isEmpty(this.channelData)) {
						this.$message.warning("暂无可关联的渠道");
						return;
					}
					await this.getAreadyChannel(this.params.appInfoId);
					this.dialogVisible = true;

					break;
				case "pay":
					this.flag = false;
					this.loading = true;
					this.params = JSON.parse(JSON.stringify(row));
					// 先获取其主体下 已经关联的渠道--展示出来
					await this.getAreadyChannel(this.params.appInfoId);

					if (isEmpty(this.areadyPayChannnel)) {
						this.$message.warning("暂无可关联的渠道,请先关联渠道");
						return;
					}
					// if (this.params.companyVo) {
					//
					// }
					this.getPlayItems(); //先获取下拉菜单可选项
					this.getPlayment(this.params.appInfoId);
					this.dialogVisible = true;
					break;
				case "nav":
					this.flag = false;
					this.params = JSON.parse(JSON.stringify(row));
					await this.getNavList();
					if (isEmpty(this.navList)) {
						this.$message.warning("暂无导航，请先配置");
						return;
					}
					await this.areadyNav(this.params.appInfoId);
					if (this.params.appType == "WX_XCX" || this.params.appType == "APP") {
						this.cardialogVisible = true;
						this.getAllids();
					} else {
						this.dialogVisible = true;
					}
					break;
				case "service":
					this.flag = false;
					this.params = JSON.parse(JSON.stringify(row));
					await this.getServiceList();
					if (isEmpty(this.serviceList)) {
						this.$message.warning("暂无客服，请先配置");
						return;
					}
					await this.areadyService(this.params.appInfoId);

					this.dialogVisible = true;
					break;
				case "agreement":
					this.flag = false;
					this.params = JSON.parse(JSON.stringify(row));
					await this.getAgreementList();
					if (isEmpty(this.agreementList)) {
						this.$message.warning("该主体下暂无可关联的协议");
						return;
					}
					await this.areadyAgreement(this.params.appInfoId);
					this.dialogVisible = true;

					break;
				case "content":
					let temp = {
						appName: row.appName,
						appTypeName: row.appTypeName,
						appid: row.appid,
						appInfoId: row.appInfoId,
					};
					// if (!isEmpty(row.companyVo.companyId)) {
					//   temp.companyId = row.companyVo.companyId;
					// }
					if (!isEmpty(row.companyId)) {
						temp.companyId = row.companyId;
					}
					this.$router.push({
						name: "APP_CONTENT",
						query: temp,
					});
					break;
				case "advertising":
					this.$router.push({
						name: "WECHAT_APP_ADVERTISING",
						query: {
							appName: row.appName,
							appTypeName: row.appTypeName,
							appid: row.appid,
							appInfoId: row.appInfoId,
						},
					});
					break;
				case "keyword":
					this.$router.push({
						name: "WECHAT_KEYWORD_LIST",
						query: {
							appName: row.appName,
							appTypeName: row.appTypeName,
							appid: row.appid,
							appInfoId: row.appInfoId,
						},
					});
					break;
			}
		},

		async getAllids() {
			this.loading = true;
			const { data: resData } = await this.$get(
				"/app/cat/info/ids?appInfoId=" + this.params.appInfoId
			);
			this.loading = false;
			if (resData.result != 200) return;
			if (resData.data) {
				this.carAppDataIds = resData.data;
			} else {
				this.carAppDataIds = [];
			}
			this.getInfoRoleListTree();
		},

		async getInfoRoleListTree() {
			let http = `/app/cat/info/list?paging=false`;
			this.loading = true;
			const { data: resData } = await this.$get(http);
			this.loading = false;
			resData.data.map((item) => {
				if (this.carAppDataIds.length) {
					for (let i = 0; i < this.carAppDataIds.length; i++) {
						if (item.appCatInfoId == this.carAppDataIds[i]) {
							item.showDeactivate = true;
							break;
						} else {
							item.showDeactivate = false;
						}
					}
				} else {
					item.showDeactivate = false;
				}
			});
			this.carContentList = resData.data;
		},
		changDeactivate(e) {
			this.$confirm("是否停用当前导航?", "提示", {
				type: "warning",
			}).then(async () => {
				const { data: resData } = await this.$delete(
					`/app/cat/id/${this.params.appInfoId}/${e}`,
					{
						headers: {
							isLoading: true,
						},
					}
				);
				if (resData.result != 200) return;
				this.getAllids();
				this.$message.success("停用成功!");
			});
		},
		changEnable(e) {
			let passData = {
				appCatInfoId: e,
				appInfoId: this.params.appInfoId,
			};
			this.$confirm("是否启用当前导航?", "提示", {
				type: "warning",
			}).then(async () => {
				const { data: resData } = await this.$post(`/app/cat/id`, passData);
				if (resData.result != 200) return;
				this.getAllids();
				this.$message.success("启用成功!");
			});
		},

		async handleInfoClick(row) {
			this.loading = true;
			const { data: resData } = await this.$get(
				"/app/cat/info/" + row.appCatInfoId
			);
			this.loading = false;
			this.navigationInstructionsInfo = resData.data;
			this.navigationShow = true;
		},

		/* 弹窗点击提交 */
		//窗口--提交 修改信息
		handleEdit() {
			this.$refs.ruleForm.validate((valid) => {
				if (!valid) return;
				this.$confirm("确认提交修改, 是否继续?", "提示", {
					type: "info",
				}).then(async () => {
					let type = this.clickType;
					if (type == "add") {
						const { data: res } = await this.$post("/app/info", this.params);
						if (res.result != 200) return;
						this.$message.success("添加成功!");
					} else if (type == "edit") {
						const { data: res } = await this.$put("/app/info", this.params);
						if (res.result != 200) return;
						this.$message.success("修改成功!");
					} else if (type == "channel") {
						const { data: res } = await this.$post("/app/channel/info", {
							appInfoId: this.params.appInfoId,
							channelAccountIds: this.params.channelAccountIds,
						});
						if (res.result != 200) return;
						this.$message.success("关联渠道账户成功!");
					} else if (type == "pay") {
						let tempIDs = [];
						if (this.payMentListInfo.length) {
							this.payMentListInfo.map((item, index) => {
								let obj = {
									main: item.main,
									paymentMchId: item.paymentMchId,
								};
								tempIDs.push(obj);
							});
						}
						let a = "";
						tempIDs.map((item) => {
							if (item.main == 1) {
								a = 1;
							}
						});
						if (a != 1) {
							this.$message.error("主备必须有一个选中");
							return;
						}
						const { data: res } = await this.$post("/app/payment/mode/info", {
							appInfoId: this.params.appInfoId,
							channelAccountId:
								this.areadyPayChannnel[this.navIndex].channelAccountId,
							paymentType: this.chilckType,
							mode: this.radio_mode,
							paymentMchIds: tempIDs,
						});
						if (res.result != 200) return;
						this.$message.success("关联支付成功!");
					} else if (type == "nav") {
						const { data: res } = await this.$post("/app/unite/nav/ids", {
							appInfoId: this.params.appInfoId,
							ids: this.checkListNav,
						});
						if (res.result != 200) return;
						this.$message.success("关联导航成功!");
					} else if (type == "service") {
						const { data: res } = await this.$post(
							"/app/unite/customer/service/ids",
							{
								appInfoId: this.params.appInfoId,
								ids: this.checkListService,
							}
						);
						if (res.result != 200) return;
						this.$message.success("关联客服成功!");
					} else if (type == "agreement") {
						if (!isEmpty(this.checkListAgreement)) {
							let temp = JSON.parse(JSON.stringify(this.checkListAgreement));
							let arry = [];
							for (let a = 0; a < temp.length; a++) {
								if (temp[a] != null) {
									arry.push(temp[a]);
								}
							}
							this.checkListAgreement = arry;
						}
						const { data: res } = await this.$post("/app/unite/protocol/ids", {
							appInfoId: this.params.appInfoId,
							ids: this.checkListAgreement,
						});
						if (res.result != 200) return;
						this.$message.success("关联协议成功!");
					}
					if (type != "pay") {
						this.queryTableData();
						this.dialogVisible = false; //弹窗隐藏
					}
				});
			});
			this.clearStore();
		},

		/* 删除 */
		handleDelete(row) {
			this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
				type: "warning",
			}).then(async () => {
				const { data: resData } = await this.$delete(
					`/app/info/${row.appInfoId}`,
					{
						headers: {
							isLoading: true,
						},
					}
				);
				if (resData.result != 200) return;
				this.queryTableData();
				this.$message.success("删除成功!");
			});
			this.clearStore();
		},

		/* 广告--渠道+code  的点击 */
		activeEventNav(index, channelAccountId) {
			this.navIndex = index;
			this.loading = true;
			this.getPlayment(this.params.appInfoId);
			// 重新调用渲染接口添加默认数据
			this.getPlayItems();
		},

		// 外层表格状态
		changeSwitch(row) {
			this.$put(`/app/info/status/${row.appInfoId}`).then((res) => {
				if (res.data.result == 200) {
					this.$message.success("操作成功");
				}
			});
			this.clearStore();
		},

		//分页
		handleSizeChange(val) {
			this.pages.pageSize = val;
			// this.getRoleListTree();
			this.queryTableData();
		},
		handleCurrentChange(val) {
			this.pages.pageNo = val;
			// this.getRoleListTree();
			this.queryTableData();
		},
	},
};
</script>

<style lang="scss" scoped>
.tag-marr {
	margin-right: 5px;
	cursor: pointer;
}

.active-bg1 {
	background: #fbc4c4;
	color: #fff;
}

.order-orderlist {
	height: 300px;
	//background-color: #3a8ee6;
}

.oerdasf {
	width: 500px;
	margin: 20px auto;
}

.el-button {
	margin-right: 10px;
	margin-left: 0;
}

.info_tabs_wechat {
	cursor: pointer;

	.radio_box {
		display: flex;
		align-items: center;
		margin-bottom: 20px;
		font-size: 14px;

		div:nth-child(1) {
			width: 98px;
			text-align: right;
			padding-right: 14px;
		}
	}

	.box_chang_info {
		display: flex;
		margin-bottom: 20px;
		font-size: 14px;

		> div:nth-child(1) {
			width: 98px;
			text-align: right;
			padding-right: 14px;
		}

		.tab_info {
			border: 1px solid #959595;
			border-bottom: 0;
			background: #ffffff;

			.tab_head_tou {
				display: flex;
				//align-items: center;
				box-sizing: border-box;
				border-bottom: 1px solid #959595;

				.td_head {
					text-align: center;
					//height: 44px;
					min-height: 44px;
					display: flex;
					justify-content: center;
					align-items: center;
					border-right: 1px solid #959595;
				}

				.one_line {
					width: 80px;
				}

				.two_line {
					width: 280px;
				}

				.last_line {
					border-right: 0;
				}
			}

			._tab_add {
				height: 44px;
				font-size: 28px;
				display: flex;
				align-items: center;
				justify-content: center;
				color: #959595;
			}
		}
	}
}

.left_box_infos {
	width: 90%;
	cursor: pointer;
	height: 400px;
	overflow-y: scroll;
	border: 1px solid #959595;
	padding: 10px;

	.cou_infos {
		margin-bottom: 10px;
	}
}

.line_td {
	padding: 5px;
	border-bottom: 1px solid #959595;
}

.last_line_to {
	border-bottom: 0;
}

.box_chang_info {
	display: flex;
	margin-bottom: 20px;
	font-size: 14px;

	.tab_info {
		border: 1px solid #959595;
		border-bottom: 0;
		background: #ffffff;

		.tab_head_tou {
			display: flex;
			align-items: center;
			box-sizing: border-box;
			border-bottom: 1px solid #959595;

			.td_head {
				text-align: center;
				height: 44px;
				line-height: 44px;
				border-right: 1px solid #959595;

				img {
					width: 80%;
					height: 80%;
					object-fit: contain;
				}
			}

			.one_line {
				width: 80px;
			}

			.class_box {
				width: 120px;
			}

			.serial {
				width: 60px;
			}

			.name_box {
				width: 160px;
			}

			.two_line {
				width: 280px;
			}

			.last_line {
				border-right: 0;
				width: 160px;
			}
		}

		.content {
			.two_line {
				width: 80px;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}

		._tab_add {
			height: 44px;
			font-size: 28px;
			display: flex;
			align-items: center;
			justify-content: center;
			color: #959595;
		}
	}
}

.box_chang_info > div:nth-child(1) {
	width: 80px;
	text-align: right;
}
</style>
